import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const TestimonialsSectionWrapper = styled.div`
  background: ${theme.whiteText};
  padding: 40px 0 40px 40px;
  width: 1200px;
  margin: 0 auto;
  border-radius: 16px;
`;

export const TestimonialsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-right: 40px;
`;

export const TestimonialsSectionTitle = styled.h2`
  font-weight: 900;
  font-size: 32px;
  color: ${theme.blackText};
`;

export const CarouselButton = styled.div`
  display: flex;
  border-radius: 24px;
  padding: 8px;
  box-shadow: 0px 2px 7px 0px #0000003d;
`;

export const ChevStateWrap = styled.button<{ left?: boolean }>`
  cursor: pointer;
  border: none;
  background: none;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
  ${(p) =>
    p.left
      ? `
transform:rotate(90deg);
`
      : `
transform:rotate(-90deg);
`}
`;

export const CarouselWrapper = styled.div`
  position: relative;
  padding-right: 40px;
`;

export const CarouselContent = styled.div`
  overflow: hidden;
`;

export const CardsContainer = styled.div<{
  currentIndex: number;
  itemsPerView: number;
}>`
  display: flex;
  gap: 24px;
  transition: transform 0.5s ease-in-out;
  transform: translateX(
    -${(props) => props.currentIndex * (100 / props.itemsPerView)}%
  );
`;

export const TestimonialCard = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 500px;
  border-radius: 16px;
  padding: 24px;
  flex-shrink: 0;
  border: 1px solid ${theme.lightSilver};
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BoughtFor = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const BoughtForLabel = styled.span`
  font-size: 14px;
  color: #000;
  font-weight: 400;
`;

export const BoughtForCountry = styled.span`
  font-size: 14px;
  color: #008cff;
  font-weight: 600;
`;

export const StarsContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const Star = styled.span<{ filled: boolean }>`
  color: ${(props) => (props.filled ? "#FFA500" : "#E0E0E0")};
  font-size: 20px;
`;

export const TestimonialContent = styled.div`
  color: ${theme.blackText};
  margin-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  position: relative;
  font-weight: 400;
  font-size: 16px;
`;

export const AuthorSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: auto;
`;

export const ProfileIcon = styled.img`
  width: 56.8px;
  height: 56.8px;
  object-fit: cover;
`;

export const AuthorDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AuthorName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #000;
`;

export const DatePosted = styled.span`
  font-size: 12px;
  color: #666;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
`;

export const Dot = styled.button<{ active: boolean }>`
  width: ${(props) => (props.active ? "24px" : "8px")};
  height: 8px;
  border-radius: 4px;
  border: none;
  background-color: ${(props) => (props.active ? "#008CFF" : "#D0D0D0")};
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    background-color: ${(props) => (props.active ? "#008CFF" : "#A0A0A0")};
  }
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  top: 240px;
  right: 20px;
  background: #2a5660;
  color: #fff;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 13px;
  max-width: 328px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: "";
    position: absolute;
    top: -6px;
    right: 150px;
    width: 12px;
    height: 12px;
    background: #2a5660;
    transform: rotate(45deg);
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: auto;

  &:hover {
    opacity: 0.8;
  }
`;

export const Separator = styled.div`
  height: 1px;
  background: #d8d8d8;
  margin: 16px 0;
`;
